// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* View Test Case — modal (default) and embedded page variant.
   Uses theme tokens only, so light/dark follow [data-theme] automatically. */

/* ── Shell ─────────────────────────────────────────────── */
.view-test-case-modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Keep the panel clear of the fixed navbar (min-height 64px) */
  padding: 80px 24px 24px;
  background: rgba(15, 23, 42, 0.5);
  z-index: 11000;
  animation: instantModalOverlayFadeIn 0.12s ease-out;
}

/* Portaled dropdowns (filters, rows-per-page) must sit above the overlay */
body:has(.view-test-case-modal-overlay) .rt-select__menu--portal {
  z-index: 11010;
}

.vtc-panel {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1080px;
  height: min(800px, calc(100vh - 104px));
  height: min(800px, calc(100dvh - 104px));
  background: var(--surface);
  color: var(--text-primary);
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
  overflow: hidden;
}

.vtc-panel:focus {
  outline: none;
}

/* Page variant: fill the shell's visible area so the tab body scrolls inside
   the panel (as in the modal) and the footer never overlaps content.
   Without :has() support the panel just grows with its content and the page scrolls. */
.rt2-main:has(> .rt-page .vtc-panel--page) {
  display: flex;
  flex-direction: column;
}

.rt2-main:has(> .rt-page .vtc-panel--page) > .rt-page {
  flex: 1 1 auto;
  min-height: 0;
}

.rt-view-as-page,
.vtc-page-host {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
}

.vtc-panel--page {
  flex: 1 1 auto;
  max-width: none;
  height: auto;
  /* On very short viewports the page scrolls instead of crushing the panel */
  min-height: 420px;
  border-radius: var(--radius-lg);
  box-shadow: none;
}

/* ── Header ────────────────────────────────────────────── */
.vtc-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px 20px 16px 24px;
}

.vtc-header__main {
  flex: 1 1;
  min-width: 0;
}

.vtc-eyebrow {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 4px;
  font-size: var(--text-xs);
  font-weight: var(--font-semibold);
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.vtc-eyebrow__id {
  font-family: var(--font-mono);
  font-weight: var(--font-medium);
  letter-spacing: 0;
  text-transform: none;
  color: var(--text-secondary);
}

.vtc-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  margin: 0;
  overflow: hidden;
  font-size: var(--text-xl);
  font-weight: var(--font-semibold);
  line-height: 1.35;
  letter-spacing: -0.01em;
  color: var(--text-primary);
  overflow-wrap: anywhere;
}

.vtc-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  margin: 12px 0 0;
}

.vtc-meta__item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.vtc-meta__item dt {
  font-size: var(--text-xs);
  color: var(--text-muted);
}

.vtc-meta__item dd {
  margin: 0;
}

.vtc-close {
  flex-shrink: 0;
  margin-top: -4px;
}

/* ── Tabs ──────────────────────────────────────────────── */
.vtc-tabs-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 24px;
  border-bottom: 1px solid var(--border);
}

.vtc-tabs {
  display: flex;
  gap: 4px;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: none;
}

.vtc-tabs::-webkit-scrollbar {
  display: none;
}

.vtc-tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: -1px;
  padding: 12px 12px 10px;
  border: none;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: var(--text-muted);
  font: inherit;
  font-size: var(--text-sm);
  font-weight: var(--font-medium);
  white-space: nowrap;
  cursor: pointer;
  transition: color var(--transition-fast), border-color var(--transition-fast);
}

.vtc-tab:hover {
  color: var(--text-primary);
}

.vtc-tab:focus-visible {
  outline: none;
  border-radius: var(--radius-sm) var(--radius-sm) 0 0;
  box-shadow: inset var(--shadow-focus);
}

.vtc-tab--active,
.vtc-tab--active:hover {
  color: var(--primary);
  border-bottom-color: var(--primary);
  font-weight: var(--font-semibold);
}

.vtc-tab__count {
  min-width: 20px;
  height: 18px;
  padding: 0 6px;
  border-radius: var(--radius-full);
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  font-size: 11px;
  font-weight: var(--font-semibold);
  line-height: 18px;
  text-align: center;
  font-variant-numeric: tabular-nums;
}

.vtc-tab--active .vtc-tab__count {
  background: var(--primary-muted);
  color: var(--primary);
}

.vtc-refreshing {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
  font-size: var(--text-xs);
  color: var(--text-muted);
  white-space: nowrap;
}

/* ── Body ──────────────────────────────────────────────── */
.vtc-body {
  /* Contain visually-hidden (absolute) labels so they scroll with the body
     instead of overflowing the panel */
  position: relative;
  flex: 1 1;
  min-height: 0;
  padding: 20px 24px 24px;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.vtc-body:focus-visible {
  outline: none;
  box-shadow: inset var(--shadow-focus);
}

.vtc-stack {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.vtc-alert {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  padding: 8px 8px 8px 12px;
  border: 1px solid color-mix(in srgb, var(--warning) 35%, transparent);
  border-radius: var(--radius-md);
  background: var(--warning-muted);
  color: var(--text-primary);
  font-size: var(--text-sm);
}

.vtc-alert > svg {
  flex-shrink: 0;
  color: var(--warning);
}

.vtc-alert > span {
  flex: 1 1;
}

/* ── Sections ──────────────────────────────────────────── */
.vtc-section__header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.vtc-section__icon {
  flex-shrink: 0;
  color: var(--text-muted);
}

.vtc-section__title {
  margin: 0;
  font-size: var(--text-base);
  font-weight: var(--font-semibold);
  color: var(--text-primary);
}

.vtc-section__meta {
  font-size: var(--text-xs);
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}

.vtc-card {
  padding: 14px 16px;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--surface);
}

.vtc-prose {
  margin: 0;
  font-size: var(--text-base);
  line-height: 1.6;
  color: var(--text-primary);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.vtc-muted {
  margin: 0;
  font-size: var(--text-sm);
  color: var(--text-muted);
}

/* Numbered text lists (preconditions, expected results) */
.vtc-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.vtc-list__item {
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr);
  gap: 8px;
  font-size: var(--text-base);
  line-height: 1.55;
}

.vtc-list__index {
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}

.vtc-list__text {
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

/* Test steps */
.vtc-steps {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.vtc-step {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr);
  gap: 12px;
  align-items: start;
  padding: 12px 14px;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--surface);
  transition: border-color var(--transition-fast);
}

.vtc-step:hover {
  border-color: var(--border-strong);
}

.vtc-step__num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: var(--radius-full);
  background: var(--primary-muted);
  color: var(--primary);
  font-size: var(--text-xs);
  font-weight: var(--font-semibold);
  font-variant-numeric: tabular-nums;
}

.vtc-step__text {
  padding-top: 2px;
  font-size: var(--text-base);
  line-height: 1.55;
  color: var(--text-primary);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

/* Key/value metadata */
.vtc-fields {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px 24px;
  margin: 0;
}

.vtc-field__label {
  margin-bottom: 4px;
  font-size: 11px;
  font-weight: var(--font-semibold);
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.vtc-field__value {
  margin: 0;
  font-size: var(--text-base);
  color: var(--text-primary);
  overflow-wrap: anywhere;
}

/* Neutral chips (tags, environments) — no text-transform, values shown as entered */
.vtc-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.vtc-chip {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  height: 22px;
  padding: 0 8px;
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-sm);
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  font-size: var(--text-xs);
  font-weight: var(--font-medium);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Attachments */
.vtc-attachments {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.vtc-attachment {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 8px 8px 12px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
}

.vtc-attachment__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: var(--radius-md);
  background: var(--bg-tertiary);
  color: var(--text-muted);
}

.vtc-attachment__info {
  flex: 1 1;
  min-width: 0;
}

.vtc-attachment__name {
  overflow: hidden;
  font-size: var(--text-sm);
  font-weight: var(--font-medium);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vtc-attachment__meta {
  font-size: var(--text-xs);
  color: var(--text-muted);
}

/* ── Execution history ─────────────────────────────────── */
/* Scrolls with the tab body like the other tabs; the table wrap only scrolls
   horizontally on narrow screens. */
.vtc-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.vtc-toolbar__title {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.vtc-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.vtc-filters .rt-select {
  min-width: 160px;
}

.vtc-history__table {
  transition: opacity var(--transition-fast);
}

.vtc-history__table--busy {
  opacity: 0.6;
}

.vtc-history__table .rt-data-table {
  min-width: 640px;
}

.vtc-history__table .rt-data-table th:last-child,
.vtc-history__table .rt-data-table td:last-child {
  text-align: right;
}

.vtc-history .rt-pagination {
  padding-bottom: 0;
}

.vtc-run {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.vtc-run__date {
  font-weight: var(--font-medium);
  color: var(--text-primary);
  white-space: nowrap;
}

.vtc-run__id {
  font-size: var(--text-xs);
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}

.vtc-run__user {
  display: inline-block;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

/* ── Footer ────────────────────────────────────────────── */
.vtc-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 24px;
  border-top: 1px solid var(--border);
  background: var(--surface);
}

.vtc-footer__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.rt-btn.vtc-btn-danger {
  color: color-mix(in srgb, var(--danger) 85%, var(--text-primary));
}

.rt-btn.vtc-btn-danger:hover:not(:disabled) {
  background: var(--danger-muted);
  color: color-mix(in srgb, var(--danger) 85%, var(--text-primary));
}

/* ── Loading skeleton ──────────────────────────────────── */
.vtc-sk {
  height: 12px;
}

.vtc-sk--eyebrow { width: 96px; margin-bottom: 10px; }
.vtc-sk--title { width: min(420px, 70%); height: 22px; margin-bottom: 14px; }
.vtc-sk--meta { width: 220px; height: 20px; }
.vtc-sk--tab { width: 96px; height: 14px; margin: 14px 0; }
.vtc-sk--row { height: 50px; margin-bottom: 8px; border-radius: var(--radius-lg); }

.vtc-sk-tabs {
  display: flex;
  gap: 20px;
  padding: 0 24px;
  border-bottom: 1px solid var(--border);
}

/* ── Responsive ────────────────────────────────────────── */
@media (max-width: 640px) {
  .view-test-case-modal-overlay {
    padding: 72px 8px 8px;
  }

  .vtc-panel:not(.vtc-panel--page) {
    height: calc(100vh - 80px);
    height: calc(100dvh - 80px);
  }

  .vtc-header {
    padding: 16px 12px 12px 16px;
  }

  .vtc-tabs-row,
  .vtc-sk-tabs {
    padding: 0 8px;
  }

  .vtc-body {
    padding: 16px;
  }

  .vtc-footer {
    padding: 10px 12px;
    gap: 8px;
  }

  .vtc-footer__actions {
    flex-wrap: nowrap;
    gap: 6px;
  }

  /* Secondary actions collapse to icons; label stays available to assistive tech */
  .vtc-btn__label {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
  }

  .vtc-footer .rt-btn--sm:has(.vtc-btn__label) {
    width: 32px;
    padding: 0;
  }

  .vtc-filters,
  .vtc-filters .rt-select {
    width: 100%;
  }

  .vtc-filters .rt-select {
    flex: 1 1;
    min-width: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .view-test-case-modal-overlay {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/view-test-case-modal.css"],"names":[],"mappings":"AAAA;6EAC6E;;AAE7E,6DAA6D;AAC7D;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+DAA+D;EAC/D,uBAAuB;EACvB,iCAAiC;EACjC,cAAc;EACd,mDAAmD;AACrD;;AAEA,2EAA2E;AAC3E;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,uCAAuC;EACvC,wCAAwC;EACxC,0BAA0B;EAC1B,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;uFAEuF;AACvF;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,2EAA2E;EAC3E,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,iCAAiC;EACjC,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,iCAAiC;EACjC,iBAAiB;EACjB,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,6EAA6E;AAC/E;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,qCAAqC;AACvC;;AAEA;;EAEE,qBAAqB;EACrB,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;EAC5B,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,6DAA6D;AAC7D;EACE;uCACqC;EACrC,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,qEAAqE;EACrE,+BAA+B;EAC/B,gCAAgC;EAChC,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,SAAO;AACT;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,gCAAgC;EAChC,qBAAqB;EACrB,yBAAyB;EACzB,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,0BAA0B;EAC1B,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,4DAA4D;EAC5D,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,oFAAoF;AACpF;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,sCAAsC;EACtC,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,6DAA6D;AAC7D;oCACoC;AACpC;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,+BAA+B;EAC/B,iEAAiE;AACnE;;AAEA,6DAA6D;AAC7D;EACE,YAAY;AACd;;AAEA,mBAAmB,WAAW,EAAE,mBAAmB,EAAE;AACrD,iBAAiB,sBAAsB,EAAE,YAAY,EAAE,mBAAmB,EAAE;AAC5E,gBAAgB,YAAY,EAAE,YAAY,EAAE;AAC5C,eAAe,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;AAC1D,eAAe,YAAY,EAAE,kBAAkB,EAAE,+BAA+B,EAAE;;AAElF;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,sCAAsC;AACxC;;AAEA,6DAA6D;AAC7D;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA,iFAAiF;EACjF;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,SAAO;IACP,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* View Test Case — modal (default) and embedded page variant.\n   Uses theme tokens only, so light/dark follow [data-theme] automatically. */\n\n/* ── Shell ─────────────────────────────────────────────── */\n.view-test-case-modal-overlay {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* Keep the panel clear of the fixed navbar (min-height 64px) */\n  padding: 80px 24px 24px;\n  background: rgba(15, 23, 42, 0.5);\n  z-index: 11000;\n  animation: instantModalOverlayFadeIn 0.12s ease-out;\n}\n\n/* Portaled dropdowns (filters, rows-per-page) must sit above the overlay */\nbody:has(.view-test-case-modal-overlay) .rt-select__menu--portal {\n  z-index: 11010;\n}\n\n.vtc-panel {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 1080px;\n  height: min(800px, calc(100vh - 104px));\n  height: min(800px, calc(100dvh - 104px));\n  background: var(--surface);\n  color: var(--text-primary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-lg);\n  overflow: hidden;\n}\n\n.vtc-panel:focus {\n  outline: none;\n}\n\n/* Page variant: fill the shell's visible area so the tab body scrolls inside\n   the panel (as in the modal) and the footer never overlaps content.\n   Without :has() support the panel just grows with its content and the page scrolls. */\n.rt2-main:has(> .rt-page .vtc-panel--page) {\n  display: flex;\n  flex-direction: column;\n}\n\n.rt2-main:has(> .rt-page .vtc-panel--page) > .rt-page {\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.rt-view-as-page,\n.vtc-page-host {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.vtc-panel--page {\n  flex: 1 1 auto;\n  max-width: none;\n  height: auto;\n  /* On very short viewports the page scrolls instead of crushing the panel */\n  min-height: 420px;\n  border-radius: var(--radius-lg);\n  box-shadow: none;\n}\n\n/* ── Header ────────────────────────────────────────────── */\n.vtc-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 20px 20px 16px 24px;\n}\n\n.vtc-header__main {\n  flex: 1;\n  min-width: 0;\n}\n\n.vtc-eyebrow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 4px;\n  font-size: var(--text-xs);\n  font-weight: var(--font-semibold);\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.vtc-eyebrow__id {\n  font-family: var(--font-mono);\n  font-weight: var(--font-medium);\n  letter-spacing: 0;\n  text-transform: none;\n  color: var(--text-secondary);\n}\n\n.vtc-title {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  margin: 0;\n  overflow: hidden;\n  font-size: var(--text-xl);\n  font-weight: var(--font-semibold);\n  line-height: 1.35;\n  letter-spacing: -0.01em;\n  color: var(--text-primary);\n  overflow-wrap: anywhere;\n}\n\n.vtc-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px 16px;\n  margin: 12px 0 0;\n}\n\n.vtc-meta__item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.vtc-meta__item dt {\n  font-size: var(--text-xs);\n  color: var(--text-muted);\n}\n\n.vtc-meta__item dd {\n  margin: 0;\n}\n\n.vtc-close {\n  flex-shrink: 0;\n  margin-top: -4px;\n}\n\n/* ── Tabs ──────────────────────────────────────────────── */\n.vtc-tabs-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 0 24px;\n  border-bottom: 1px solid var(--border);\n}\n\n.vtc-tabs {\n  display: flex;\n  gap: 4px;\n  min-width: 0;\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n\n.vtc-tabs::-webkit-scrollbar {\n  display: none;\n}\n\n.vtc-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: -1px;\n  padding: 12px 12px 10px;\n  border: none;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n  color: var(--text-muted);\n  font: inherit;\n  font-size: var(--text-sm);\n  font-weight: var(--font-medium);\n  white-space: nowrap;\n  cursor: pointer;\n  transition: color var(--transition-fast), border-color var(--transition-fast);\n}\n\n.vtc-tab:hover {\n  color: var(--text-primary);\n}\n\n.vtc-tab:focus-visible {\n  outline: none;\n  border-radius: var(--radius-sm) var(--radius-sm) 0 0;\n  box-shadow: inset var(--shadow-focus);\n}\n\n.vtc-tab--active,\n.vtc-tab--active:hover {\n  color: var(--primary);\n  border-bottom-color: var(--primary);\n  font-weight: var(--font-semibold);\n}\n\n.vtc-tab__count {\n  min-width: 20px;\n  height: 18px;\n  padding: 0 6px;\n  border-radius: var(--radius-full);\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  font-size: 11px;\n  font-weight: var(--font-semibold);\n  line-height: 18px;\n  text-align: center;\n  font-variant-numeric: tabular-nums;\n}\n\n.vtc-tab--active .vtc-tab__count {\n  background: var(--primary-muted);\n  color: var(--primary);\n}\n\n.vtc-refreshing {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: auto;\n  font-size: var(--text-xs);\n  color: var(--text-muted);\n  white-space: nowrap;\n}\n\n/* ── Body ──────────────────────────────────────────────── */\n.vtc-body {\n  /* Contain visually-hidden (absolute) labels so they scroll with the body\n     instead of overflowing the panel */\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  padding: 20px 24px 24px;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n\n.vtc-body:focus-visible {\n  outline: none;\n  box-shadow: inset var(--shadow-focus);\n}\n\n.vtc-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.vtc-alert {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n  padding: 8px 8px 8px 12px;\n  border: 1px solid color-mix(in srgb, var(--warning) 35%, transparent);\n  border-radius: var(--radius-md);\n  background: var(--warning-muted);\n  color: var(--text-primary);\n  font-size: var(--text-sm);\n}\n\n.vtc-alert > svg {\n  flex-shrink: 0;\n  color: var(--warning);\n}\n\n.vtc-alert > span {\n  flex: 1;\n}\n\n/* ── Sections ──────────────────────────────────────────── */\n.vtc-section__header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.vtc-section__icon {\n  flex-shrink: 0;\n  color: var(--text-muted);\n}\n\n.vtc-section__title {\n  margin: 0;\n  font-size: var(--text-base);\n  font-weight: var(--font-semibold);\n  color: var(--text-primary);\n}\n\n.vtc-section__meta {\n  font-size: var(--text-xs);\n  color: var(--text-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n.vtc-card {\n  padding: 14px 16px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  background: var(--surface);\n}\n\n.vtc-prose {\n  margin: 0;\n  font-size: var(--text-base);\n  line-height: 1.6;\n  color: var(--text-primary);\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.vtc-muted {\n  margin: 0;\n  font-size: var(--text-sm);\n  color: var(--text-muted);\n}\n\n/* Numbered text lists (preconditions, expected results) */\n.vtc-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.vtc-list__item {\n  display: grid;\n  grid-template-columns: 20px minmax(0, 1fr);\n  gap: 8px;\n  font-size: var(--text-base);\n  line-height: 1.55;\n}\n\n.vtc-list__index {\n  color: var(--text-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n.vtc-list__text {\n  overflow-wrap: anywhere;\n  white-space: pre-wrap;\n}\n\n/* Test steps */\n.vtc-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.vtc-step {\n  display: grid;\n  grid-template-columns: 24px minmax(0, 1fr);\n  gap: 12px;\n  align-items: start;\n  padding: 12px 14px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  background: var(--surface);\n  transition: border-color var(--transition-fast);\n}\n\n.vtc-step:hover {\n  border-color: var(--border-strong);\n}\n\n.vtc-step__num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: var(--radius-full);\n  background: var(--primary-muted);\n  color: var(--primary);\n  font-size: var(--text-xs);\n  font-weight: var(--font-semibold);\n  font-variant-numeric: tabular-nums;\n}\n\n.vtc-step__text {\n  padding-top: 2px;\n  font-size: var(--text-base);\n  line-height: 1.55;\n  color: var(--text-primary);\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n/* Key/value metadata */\n.vtc-fields {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 16px 24px;\n  margin: 0;\n}\n\n.vtc-field__label {\n  margin-bottom: 4px;\n  font-size: 11px;\n  font-weight: var(--font-semibold);\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.vtc-field__value {\n  margin: 0;\n  font-size: var(--text-base);\n  color: var(--text-primary);\n  overflow-wrap: anywhere;\n}\n\n/* Neutral chips (tags, environments) — no text-transform, values shown as entered */\n.vtc-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.vtc-chip {\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  height: 22px;\n  padding: 0 8px;\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-sm);\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  font-size: var(--text-xs);\n  font-weight: var(--font-medium);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Attachments */\n.vtc-attachments {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.vtc-attachment {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 8px 8px 12px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n}\n\n.vtc-attachment__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-md);\n  background: var(--bg-tertiary);\n  color: var(--text-muted);\n}\n\n.vtc-attachment__info {\n  flex: 1;\n  min-width: 0;\n}\n\n.vtc-attachment__name {\n  overflow: hidden;\n  font-size: var(--text-sm);\n  font-weight: var(--font-medium);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vtc-attachment__meta {\n  font-size: var(--text-xs);\n  color: var(--text-muted);\n}\n\n/* ── Execution history ─────────────────────────────────── */\n/* Scrolls with the tab body like the other tabs; the table wrap only scrolls\n   horizontally on narrow screens. */\n.vtc-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.vtc-toolbar__title {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.vtc-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.vtc-filters .rt-select {\n  min-width: 160px;\n}\n\n.vtc-history__table {\n  transition: opacity var(--transition-fast);\n}\n\n.vtc-history__table--busy {\n  opacity: 0.6;\n}\n\n.vtc-history__table .rt-data-table {\n  min-width: 640px;\n}\n\n.vtc-history__table .rt-data-table th:last-child,\n.vtc-history__table .rt-data-table td:last-child {\n  text-align: right;\n}\n\n.vtc-history .rt-pagination {\n  padding-bottom: 0;\n}\n\n.vtc-run {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.vtc-run__date {\n  font-weight: var(--font-medium);\n  color: var(--text-primary);\n  white-space: nowrap;\n}\n\n.vtc-run__id {\n  font-size: var(--text-xs);\n  color: var(--text-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n.vtc-run__user {\n  display: inline-block;\n  max-width: 180px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n/* ── Footer ────────────────────────────────────────────── */\n.vtc-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 12px 24px;\n  border-top: 1px solid var(--border);\n  background: var(--surface);\n}\n\n.vtc-footer__actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.rt-btn.vtc-btn-danger {\n  color: color-mix(in srgb, var(--danger) 85%, var(--text-primary));\n}\n\n.rt-btn.vtc-btn-danger:hover:not(:disabled) {\n  background: var(--danger-muted);\n  color: color-mix(in srgb, var(--danger) 85%, var(--text-primary));\n}\n\n/* ── Loading skeleton ──────────────────────────────────── */\n.vtc-sk {\n  height: 12px;\n}\n\n.vtc-sk--eyebrow { width: 96px; margin-bottom: 10px; }\n.vtc-sk--title { width: min(420px, 70%); height: 22px; margin-bottom: 14px; }\n.vtc-sk--meta { width: 220px; height: 20px; }\n.vtc-sk--tab { width: 96px; height: 14px; margin: 14px 0; }\n.vtc-sk--row { height: 50px; margin-bottom: 8px; border-radius: var(--radius-lg); }\n\n.vtc-sk-tabs {\n  display: flex;\n  gap: 20px;\n  padding: 0 24px;\n  border-bottom: 1px solid var(--border);\n}\n\n/* ── Responsive ────────────────────────────────────────── */\n@media (max-width: 640px) {\n  .view-test-case-modal-overlay {\n    padding: 72px 8px 8px;\n  }\n\n  .vtc-panel:not(.vtc-panel--page) {\n    height: calc(100vh - 80px);\n    height: calc(100dvh - 80px);\n  }\n\n  .vtc-header {\n    padding: 16px 12px 12px 16px;\n  }\n\n  .vtc-tabs-row,\n  .vtc-sk-tabs {\n    padding: 0 8px;\n  }\n\n  .vtc-body {\n    padding: 16px;\n  }\n\n  .vtc-footer {\n    padding: 10px 12px;\n    gap: 8px;\n  }\n\n  .vtc-footer__actions {\n    flex-wrap: nowrap;\n    gap: 6px;\n  }\n\n  /* Secondary actions collapse to icons; label stays available to assistive tech */\n  .vtc-btn__label {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n    clip: rect(0 0 0 0);\n    white-space: nowrap;\n  }\n\n  .vtc-footer .rt-btn--sm:has(.vtc-btn__label) {\n    width: 32px;\n    padding: 0;\n  }\n\n  .vtc-filters,\n  .vtc-filters .rt-select {\n    width: 100%;\n  }\n\n  .vtc-filters .rt-select {\n    flex: 1;\n    min-width: 0;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .view-test-case-modal-overlay {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
